export default class PopupImage {
  targetClass: string
  targetArray: NodeListOf<HTMLElement> | null | undefined
  popupContainer: HTMLDivElement
  popupImageElm: HTMLImageElement

  constructor(config: { targetClass?: string }) {
    this.targetClass = config.targetClass || 'popup'
    this.targetArray = document.querySelectorAll(`a.${this.targetClass}`)

    const createElm = this.createPopupElement()

    this.popupContainer = createElm.container
    this.popupImageElm = createElm.image

    // イベント
    this.targetArray.forEach((elm) => {
      elm.addEventListener('click', (e: MouseEvent) => this.openPopup(e))
    })

    this.popupContainer.addEventListener('click', (e: MouseEvent) =>
      this.closePopup(e)
    )

    this.popupImageElm.addEventListener('load', (e: Event) =>
      this.imageLoadEnd(e)
    )
  }

  openPopup(e: MouseEvent) {
    e.preventDefault()

    const imageUrl = this.getImageUrl(e.currentTarget)
    if (!imageUrl) return

    this.openElement(imageUrl)

    document.body.style.overflow = 'hidden'
    document.body.style.height = '100%'
  }

  closePopup(e: MouseEvent) {
    document.body.style.overflow = ''
    document.body.style.height = ''

    this.hiddenElement(e)
  }

  openElement(imageUrl: string) {
    this.popupImageElm.src = imageUrl
    this.popupContainer.style.opacity = '1'
    this.popupContainer.style.pointerEvents = 'all'
  }

  imageLoadEnd(e: Event) {
    console.log('imageLoadend')
  }

  hiddenElement(e: MouseEvent) {
    const target = e.target as HTMLElement
    if (this.popupImageElm == target) return

    this.popupImageElm.src = ''
    this.popupContainer.style.opacity = '0'
    this.popupContainer.style.pointerEvents = 'none'
  }

  getImageUrl(elm: EventTarget | null) {
    if (!elm) return

    const target = elm as HTMLElement
    const imageUrl = target.getAttribute('href')

    return imageUrl
  }

  createPopupElement(): {
    container: HTMLDivElement
    image: HTMLImageElement
  } {
    const container = document.createElement('div')
    container.style.position = 'fixed'
    container.style.top = '0'
    container.style.left = '0'
    container.style.zIndex = '9999'
    container.style.width = '100%'
    container.style.height = '100%'
    container.style.backgroundColor = 'rgba(0 0 0 / 50%)'
    container.style.display = 'flex'
    container.style.justifyContent = 'center'
    container.style.alignItems = 'center'
    container.style.opacity = '0'
    container.style.pointerEvents = 'none'

    const imageBlock = document.createElement('div')
    imageBlock.style.maxWidth = '90%'
    imageBlock.style.maxHeight = '90%'
    imageBlock.style.display = 'flex'
    imageBlock.style.justifyContent = 'center'
    imageBlock.style.alignItems = 'center'
    imageBlock.style.position = 'relative'

    const closeBtnOuter = document.createElement('div')
    closeBtnOuter.style.width = '2.5em'
    closeBtnOuter.style.height = '2.5em'
    closeBtnOuter.style.position = 'absolute'
    closeBtnOuter.style.top = '1em'
    closeBtnOuter.style.right = '1em'
    closeBtnOuter.style.backgroundColor = 'rgba(0 0 0 / 40%)'
    closeBtnOuter.style.borderRadius = '50%'
    closeBtnOuter.classList.add('popup_close-btn-outer')
    window.getComputedStyle(closeBtnOuter, '::before')

    const closeBtn = document.createElement('div')
    closeBtn.style.width = '100%'
    closeBtn.style.height = '100%'
    closeBtn.style.position = 'relative'
    closeBtn.style.cursor = 'pointer'
    closeBtn.classList.add('popup_close-btn')
    window.getComputedStyle(closeBtn, '::before')
    window.getComputedStyle(closeBtn, '::after')

    const sheets = document.styleSheets
    const sheet = sheets[sheets.length - 1]
    sheet.insertRule(
      `
      .popup_close-btn-outer::before { 
        content: "";
        display: block;
        width: 150%;
        height: 150%;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      `,
      sheet.cssRules.length
    )
    sheet.insertRule(
      `
      .popup_close-btn::before { 
        content: "";
        display: block;
        width: 60%;
        height: 2px;
        border-radius: 2px;
        background-color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
      `,
      sheet.cssRules.length
    )
    sheet.insertRule(
      `
      .popup_close-btn::after { 
        content: "";
        display: block;
        width: 60%;
        height: 2px;
        border-radius: 2px;
        background-color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
      `,
      sheet.cssRules.length
    )

    const image = document.createElement('img')
    image.style.display = 'block'
    image.style.maxWidth = '100%'
    image.style.maxHeight = '100%'
    image.style.objectFit = 'contain'

    imageBlock.append(image)
    closeBtnOuter.append(closeBtn)
    imageBlock.append(closeBtnOuter)
    container.append(imageBlock)
    document.body.append(container)

    return {
      container: container,
      image: image,
    }
  }
}
